// firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCFa34udaWK9z8dUbYtt0DrIY3mc-nbyVk",
  authDomain: "esg-data-ea8f7.firebaseapp.com",
  projectId: "esg-data-ea8f7",
  storageBucket: "esg-data-ea8f7.firebasestorage.app",
  messagingSenderId: "629845828064",
  appId: "1:629845828064:web:87ac31663d9fab5f218b85",
  measurementId: "G-XPH509XVQE",
};

const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);
const db = getFirestore(app);

export { db, auth };
